module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Marmitaria Villaris","short_name":"Villaris","description":"Marmitas congeladas caseiras no Ipiranga e região.","start_url":"/","background_color":"#FDF1E5","theme_color":"#F6A437","display":"minimal-ui","icon":"static/images/logo.jpeg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"d95f09a074077379255476bd428144fc"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
